import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to the top on every route change. React Router keeps the
 * previous scroll offset by default, which made pages (e.g. product detail)
 * open scrolled half-way down. Mounting this once inside <BrowserRouter>
 * fixes it for every page.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // Run after paint so the new page content is mounted first.
    window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
